import React from 'react';
import PropTypes from 'prop-types';
import { WalkScoreSvg, ScoreBadge } from '~/legacy/components';

function WalkScoreBadge({
  walkscore,
  description,
  helpLink,
  titleVariant,
  fontSize,
  height,
}) {
  const walkScoreSvg = (
    <WalkScoreSvg walkscore={walkscore} fontSize={fontSize} height={height} />
  );

  return (
    <ScoreBadge
      scoreName="Walk Score"
      scoreSvg={walkScoreSvg}
      titleVariant={titleVariant}
      description={description}
      helpLink={helpLink}
    />
  );
}
WalkScoreBadge.propTypes = {
  walkscore: PropTypes.number.isRequired,
  description: PropTypes.string,
  helpLink: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  fontSize: PropTypes.string,
  height: PropTypes.string,
};
WalkScoreBadge.defaultProps = {
  description: undefined,
  titleVariant: undefined,
  fontSize: undefined,
  height: undefined,
};

export default WalkScoreBadge;
